import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Badge, Col, Row } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { isEmpty, without } from 'lodash';
import { deleteTagging, fetchTaggingsForInsightsProperty, tagProperty } from 'helpers/clarity_api';
import TagPicker from './tag_picker';

export default function PropertyTags({ id }) {
  const [taggings, setTaggings] = useState();

  useEffect(() => {
    fetchTaggingsForInsightsProperty(id).then(setTaggings);
  }, []);

  const removeTagging = (tagging) => {
    deleteTagging(tagging.id)
      .then(setTaggings(without(taggings, tagging)));
  };

  const onTagSelected = (tag) => {
    tagProperty(tag.id, id).then(tagging => setTaggings([...taggings, tagging]));
  };

  return (
    <div>
      {isEmpty(taggings) && (
        <TagPicker excludeNames={[]} onTagSelected={onTagSelected} />
      )}
      {!isEmpty(taggings) && (
        <Row className="gx-2 gy-2 align-items-center">
          {taggings.map(tagging => (
            <Col key={tagging.id} xs="auto">
              <Badge bg="" className="bg-connect-tag text-body">
                <small>{tagging.name}</small>
                <FontAwesomeIcon
                  className="ms-2 clickable fw-bold"
                  icon={faTimes}
                  onClick={() => removeTagging(tagging)}
                />
              </Badge>
            </Col>
          ))}
          <Col xs="auto">
            <TagPicker excludeNames={taggings.map(({ name }) => name)} onTagSelected={onTagSelected} />
          </Col>
        </Row>
      )}
    </div>
  );
}

PropertyTags.propTypes = {
  id: PropTypes.number.isRequired
};
